import { IconButton } from '@cian/ui-kit/button';
import { IconActionShareIOS16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IShareContainerProps {
  title: string;
  url: string;
}

/**
 * Кнопка «Поделиться» через Web Share API.
 * API есть не везде (десктопные браузеры, часть Android WebView) — там кнопка не отображается.
 * Проверку делаем после монтирования, чтобы не разошлась серверная разметка.
 */
export const ShareContainer: React.FC<IShareContainerProps> = ({ title, url }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    setIsVisible(typeof window !== 'undefined' && Boolean(window.navigator.share));
  }, []);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      window.navigator.share?.({ title, url })?.catch(() => undefined);
    },
    [title, url],
  );

  if (!isVisible) {
    return null;
  }

  return (
    <IconButton
      icon={<IconActionShareIOS16 color="icon-inverted-default" />}
      onClick={handleClick}
      title="Поделиться"
      aria-label="Поделиться"
      data-name="ShareButton"
      data-testid="ShareButton"
    />
  );
};
